"use client";
import Image from 'next/image'
import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { FcGoogle } from "react-icons/fc";
import { closeModal } from '@/redux/popup/modalSlice';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { useRef, useState } from 'react';
import { useParams } from 'next/navigation';
import { FaFacebook } from 'react-icons/fa6';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { signIn } from 'next-auth/react';

const ModalLogin = () => {
  const params = useParams();
  const {locale} = params;
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const signUpInputEmail = useRef();
  const dispatch = useDispatch();  
  const [isError, setIsError] = useState("");
  
  const handleGoogleSignIn = async()=>{
     setGoogleLoading(true);
    try {
      await signIn("google");
    } finally {
      setGoogleLoading(false);
    }
  }
   const handleFacebookSignIn = async()=>{
     setGoogleLoading(true);
    try {
      await signIn("facebook");
    } finally {
      setGoogleLoading(false);
    }
  }
   const handlerSignUp = async (e) => {
     e.preventDefault();
    if (signUpInputEmail.current.value === "") {
      setIsError("Email input is not available.");
      return;
    }

    const email = signUpInputEmail.current.value.trim();
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;   
    if (!emailRegex.test(email)) {
      setIsError("Please enter a valid email address");
      return;
    }
    setIsError("");
    setLoading(true);
    let loginDetail = {
      provider_id: "",
      provider: "",
      name: "",
      email: email,
      phone: "",
      locale,
    };
    
    const status = await signIn("credentials", loginDetail, {
      redirect: false,
    });
    setLoading(false);
    if (status?.error) {
      setIsError("Login failed. Please try again.");
    }
  };
  return (
    <div className="w-screen h-screen fixed top-0 left-0 flex justify-center items-center bg-black/30 z-50">
      <div className="w-full h-screen md:w-1/2 md:h-155 rounded bg-primary-foreground shadow-lg overflow-hidden flex justify-start gap-1">
        <div className="hidden md:block md:w-96 h-162.5 relative">
          <Image
            src="/assets/img/loginimg.webp"
            alt="logining"
            fill
            priority
            sizes="(min-width: 808px) 75vw, 100vw"
            style={{
              objectFit: "cover",
            }}
          />
        </div>
        <div className="w-full md:w-[50%] px-4">
          <div className="closeIcons flex justify-end p-2 w-full">
            <span
              className="group p-1 border rounded-full cursor-pointer
             transition-all duration-300
             hover:bg-red-600"
              onClick={() => dispatch(closeModal())}
            >
              <MdClose className="text-2xl text-primary group-hover:text-white" />
            </span>
          </div>
          <div className="mt-10">
            <h2 className="text-3xl font-geistSans font-semibold text-primary/80"> Sign up</h2>
          </div>
          <div className="ftv-field mt-6 flex gap-4 justify-start pl-12 items-center py-4"  onClick={handleFacebookSignIn}>
            <FaFacebook className="text-4xl text-indigo-800" />
            <span className='text-primary/80 text-lg font-poppins font-medium'> Sign up with Facebook</span>
          </div>
          <div
            className="ftv-field mt-6 flex gap-4 justify-start pl-12 items-center py-4 cursor-pointer"
            onClick={handleGoogleSignIn}
          >
            <FcGoogle className="text-4xl" />
            <span className='text-primary/80 text-lg font-poppins font-medium'>
              {googleLoading
                ? "Google SignIn, Please wait..."
                : "Sign up with Google"}
            </span>
          </div>
          <div className="ftv-field mt-6">
            <Label className="pl-3 font-poppins font-normal text-xs text-gray-600">Email</Label>
            <Input
              className="border-transparent shadow-none text-primary/80"
              placeholder="Here"
              ref={signUpInputEmail}
            />
          </div>
          {isError && (
            <p className="text-sm font-light mt-1 text-rose-700">{isError}</p>
          )}
          <Button
            type="button"
            onClick={handlerSignUp}
            variant={"destructive"}
            className="w-full text-center h-14 text-primary/80 text-xl font-medium font-geistSans mt-5"
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
          <div className="mt-5">
            <p className="text-[13px] font-poppins font-light text-primary tracking-wide">
              <input type={"checkbox"} defaultChecked={true} /> I have reviewed
              the
              <Link
                href={`/${locale}/privacy-policy`}
                className="text-orange-600 px-2 font-poppins font-medium cursor-pointer"
              >
                Privacy Policy*
              </Link>
            </p>
            <p className="text-[13px] font-poppins font-light text-primary tracking-wide py-1">
              <input type={"checkbox"} defaultChecked={true} /> I agree to
              receive alerts via email & SMS*
            </p>
            <p className="text-[13px] font-poppins font-light text-primary tracking-wide pl-4">
              If you have an account, please
              <span className="text-orange-600 px-2 font-poppins font-medium cursor-pointer">
                Sign In
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    
  )
}

export default ModalLogin